import React from 'react';
import { ReactComponent as ErrorSvg } from '@assets/icons/error-500-icon.svg';
import Loader from '@components/Loader';

import './PlaybackPreparingLoader.less';

interface PlaybackPreparingLoaderProps {
  isVideo?: boolean;
  error?: boolean;
  /** Override the default message. Falls back to the preparing-preview /
   * preparing-for-playback copy if omitted. */
  message?: React.ReactNode;
}

function PlaybackPreparingLoader({
  isVideo,
  error,
  message
}: PlaybackPreparingLoaderProps) {
  const copy =
    message ?? (isVideo ? 'Preparing for playback...' : 'Preparing preview...');
  return (
    <div className="media_viewer_playback_container">
      <div className="media_viewer_playback_container__content">
        {!error && (
          <Loader spinSize={72} isSpinning={true} classNameWrapper="loader" />
        )}
        {error && <ErrorSvg />}
        <div className="copy">{copy}</div>
      </div>
    </div>
  );
}

export default PlaybackPreparingLoader;
